
import { defineComponent, PropType } from 'vue'
type DetailObj = { label: string; content: string }
type ApplyHotelAbstractObj = {
  name: DetailObj
  address: DetailObj
  tel: DetailObj
  program?: DetailObj
}

export default defineComponent({
  name: 'ApplyHotelAbstract',
  props: {
    hospitalList: Array as PropType<ApplyHotelAbstractObj[]>
  }
})
